import { createContext, useContext, type ReactNode } from 'react'
import { useSocket } from '@/hooks/use-socket'

interface SocketContextValue {
  isConnected: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  on: (event: string, handler: (data: any) => void) => () => void
  emit: (event: string, payload?: unknown) => void
  emitWithAuth: (event: string, payload?: Record<string, unknown>) => Promise<void>
}

const SocketContext = createContext<SocketContextValue | null>(null)

export function SocketProvider({ children }: { children: ReactNode }) {
  const { isConnected, on, emit, emitWithAuth } = useSocket()

  return (
    <SocketContext.Provider value={{ isConnected, on, emit, emitWithAuth }}>
      {children}
    </SocketContext.Provider>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export function useSocketContext() {
  const ctx = useContext(SocketContext)
  if (!ctx) throw new Error('useSocketContext must be used within SocketProvider')
  return ctx
}
